import { render, staticRenderFns } from "./FireCauseCommonPartsOrigin.vue?vue&type=template&id=4e69d6dd&scoped=true"
import script from "./FireCauseCommonPartsOrigin.vue?vue&type=script&lang=ts"
export * from "./FireCauseCommonPartsOrigin.vue?vue&type=script&lang=ts"
import style0 from "./FireCauseCommonPartsOrigin.vue?vue&type=style&index=0&id=4e69d6dd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e69d6dd",
  null
  
)

export default component.exports